import { useSelector } from 'react-redux';
import {
	SHOW_AUTH_MODAL,
	SHOW_TC_MODAL,
	ACCEPT_TERMS,
	HIDE_TC_MODAL,
	DECLINE_TERMS,
} from '@reduxLocal/actions/types';
import { DefaultRootState, store } from '@reduxLocal/persistState';

function select(state) {
	return state.modals.tcModal;
}

function handleChange(dispatch, resolve, reject, unsubscribe) {
	return function () {
		const currentValue = select(store.getState());

		if (!currentValue.modalDisplayed) {
			// Check cancellation flag to detect intentional cancel
			// This is a synchronous check, so we'll rely on the main handler for async check
			dispatch({ type: HIDE_TC_MODAL });

			// Note: The main promise handler will check AsyncStorage for cancellation flag
			// This function is kept simple for the subscription handler
			unsubscribe(); // Unsubscribe after rejection
			reject(
				new Error(
					'You must accept the terms and conditions to continue.'
				)
			);
		}

		if (currentValue.accepted) {
			console.log('Detected state change', currentValue);
			unsubscribe(); // Unsubscribe after resolution
			resolve(true);
		}
	};
}

const getTCConfirm = () => {
	const dispatch = store.dispatch;
	let settled = false;
	let unsubscribe;

	const promise = new Promise((resolve, reject) => {
		const handler = () => {
			if (settled) return;

			const currentValue = store.getState().modals.tcModal;

			if (currentValue.accepted) {
				settled = true;
				unsubscribe();
				resolve(true);
				return;
			}

			if (!currentValue.modalDisplayed) {
				settled = true;
				unsubscribe();

				// Check if user explicitly declined (intentional cancel) BEFORE dispatching HIDE_TC_MODAL
				// DECLINE_TERMS sets accepted to false, and it's dispatched before HIDE_TC_MODAL in TCModal
				const wasExplicitlyDeclined = currentValue.accepted === false;

				dispatch({ type: HIDE_TC_MODAL });

				if (!wasExplicitlyDeclined) {
					// Modal was closed but not explicitly declined - show error
					setTimeout(() => {
						dispatch({
							type: SHOW_AUTH_MODAL,
							data: {
								content:
									'You must accept the terms and conditions to continue.',
								type: 'error',
							},
						});
					}, 1000);
				} else {
					console.log(
						'[getTCConfirm] User declined terms, not showing error message'
					);
				}

				reject(
					new Error(
						'You must accept the terms and conditions to continue.'
					)
				);
			}
		};

		unsubscribe = store.subscribe(handler);
	});

	const timeoutPromise = new Promise((_, reject) => {
		setTimeout(() => {
			if (settled) return;
			settled = true;
			unsubscribe?.();
			dispatch({ type: HIDE_TC_MODAL });
			reject(new Error('Timeout: The operation took too long.'));
		}, 600000);
	});

	return Promise.race([promise, timeoutPromise]);
};


export default getTCConfirm;
